module.exports = __webpack_public_path__ + "9d94c57275c705633400cd3d1c5ecb48.png";